export default __webpack_public_path__ + "static/media/instagram.ae470458.svg";